export const SET_ACTIVE_ROUTE = 'SET_ACTIVE_ROUTE';
export function setActiveRouteAction({ routeId, params, query, details }) {
    return {
        type: SET_ACTIVE_ROUTE,
        data: { routeId, params, query, details },
    };
}
